function leerVariableDeEntorno(nombre: string, valorPorDefecto: string): string;
function leerVariableDeEntorno(nombre: string): string | undefined;
function leerVariableDeEntorno(nombre: string, valorPorDefecto?: string): string | undefined {
  return import.meta.env[nombre] || valorPorDefecto;
}

export const API_URL = leerVariableDeEntorno('VITE_API_URL', '/api');
export const GOOGLE_MAPS_API_KEY = leerVariableDeEntorno('VITE_GOOGLE_MAPS_KEY');
